import "./modal.js";

/**
 * @module page-builder
 */
(function () {
  "use strict";

  var uploadAsset = Sparkle.PageBuilder.uploadAsset;

  var VideoDialog = function VideoDialog() {
    var _super = new Sparkle.PageBuilder.Modal.Deprecated();
    var self = {};

    _.extend(self, _super, {
      template: "video-dialog",
      initialize: function (initialValue, callback, options) {
        _super.initialize.apply(this, []);

        this.options = options || {};

        if (_.isEmpty(initialValue)) {
          initialValue = null;
        }

        var segments = this.dialog.querySelector(".pane-header .segments");

        this.addButton(
          "Remove",
          function () {
            if (callback) {
              callback(null);
            }

            this.remove();
          }.bind(this),
        );

        this.addPrimaryButton(
          "Done",
          function () {
            if (callback) {
              callback(this.getValue());
            }

            this.remove();
          }.bind(this),
        );

        this.setupSearch();
        this.setupUploader();
        this.setValue(initialValue);

        if (this.value) {
          this.editAsset(this.value);
        } else {
          this.switchTo("video-upload-tab");
        }

        Sparkle.Tabs.initializeTabs(this.dialog);

        this.show();
      },

      setupSearch: function () {
        var queryElement = this.dialog.querySelector("[name=query]");
        var queryResultsElement = this.dialog.querySelector(".results");

        var search = _.debounce(
          function () {
            var url = "/admin/assets.json";
            var params = { query: queryElement.value, page_type: "Video", limit: 50, archived: false, wildcard: true };

            jQuery.get(url, params).done(
              function (json) {
                queryResultsElement.innerHTML = "";

                json.forEach(
                  function (result) {
                    var element = document.createElement("li");
                    element.innerHTML = Sparkle.HandlebarsTemplates["video-dialog-search-result"](result);
                    element.addEventListener(
                      "click",
                      function () {
                        this.selectAsset(result);
                      }.bind(this),
                    );

                    queryResultsElement.appendChild(element);
                  }.bind(this),
                );
              }.bind(this),
            );
          }.bind(this),
          300,
        );

        queryElement.addEventListener("input", search);
        search();
      },

      setupUploader: function () {
        var uploadArea = this.dialog.querySelector(".video-upload-tab");
        var fileElement = this.dialog.querySelector("[name=files]");

        var processFile = function (file) {
          var dialog = this.dialog;
          var progressTab = dialog.querySelector(".upload-progress-tab");
          var progressContainer = progressTab.querySelector(".progress-container");
          var cancelButton = progressTab.querySelector("button");

          progressTab.style.display = "block";
          jQuery(progressContainer)
            .html(jQuery("<small>").text(file.name))
            .append("<div class='progressbar'><div style='width: 0%;' /></div>");
          dialog.classList.add("uploading");

          var finishUpload = function finishUpload() {
            progressTab.style.display = "none";
            dialog.classList.remove("uploading");
          };

          var progressBar = progressContainer.querySelector(".progressbar div");
          var progress = function progress(event) {
            var percent = parseInt((event.loaded / event.total) * 100, 10);
            progressBar.style.width = percent + "%";
          };

          var upload = uploadAsset(file, progress);
          upload.then(
            function (response) {
              this.selectAsset(response);
              finishUpload();
            }.bind(this),
          );

          cancelButton.addEventListener("click", function () {
            upload.abort();
            finishUpload();
          });
        }.bind(this);

        // Upload: Dialog
        fileElement.addEventListener("change", function () {
          processFile(fileElement.files[0]);
        });

        // Upload: Drag'n'drop
        uploadArea.addEventListener("dragover", function (event) {
          event.preventDefault();
        });

        uploadArea.addEventListener("dragenter", function (event) {
          uploadArea.classList.add("drag-over");
        });

        uploadArea.addEventListener("dragleave", function (event) {
          uploadArea.classList.remove("drag-over");
        });

        uploadArea.addEventListener("dragend", function (event) {
          uploadArea.classList.remove("drag-over");
        });

        uploadArea.addEventListener("drop", function (event) {
          uploadArea.classList.remove("drag-over");
          event.preventDefault();
          event.stopPropagation();
          processFile(event.dataTransfer.files[0]);
        });
      },

      getValue: function () {
        return this.value;
      },

      setValue: function (value) {
        this.value = value;
      },

      selectAsset: function (asset) {
        this.setValue(asset);
        this.editAsset(asset);
      },

      switchTo: function (tab) {
        jQuery(this.dialog)
          .find("[aria-controls=" + tab + "]")
          .trigger("click");
      },

      editAsset: function (asset) {
        // Update highlights
        _.each(this.dialog.querySelectorAll(".selected img.active"), function (element) {
          element.classList.remove("active");
        });

        var elements = this.dialog.querySelectorAll('.selected img[src="' + asset.poster_image_path + '"]');

        _.each(elements, function (element) {
          element.classList.add("active");
        });

        // Update video element
        var selectedVideoElement = this.dialog.querySelector(".video-edit-tab");

        var name = asset.url && asset.url.split("/").slice(-1)[0];

        selectedVideoElement.innerHTML = Sparkle.HandlebarsTemplates["video-dialog-edit"]({
          id: asset.id,
          poster_image_path: asset.poster_image_path,
          url: asset.url,
          title: asset.title,
          description: asset.description,
          name: name,
          placeholders: this.options.placeholders,
        });

        var titleInput = selectedVideoElement.querySelector("[name=title]");
        titleInput.addEventListener("input", function () {
          asset.title = titleInput.value;
        });

        var descriptionInput = selectedVideoElement.querySelector("[name=description]");
        descriptionInput.addEventListener("input", function () {
          asset.description = descriptionInput.value;
        });

        this.switchTo("video-edit-tab");
      },
    });

    self.initialize.apply(self, arguments);
    return self;
  };

  Sparkle.PageBuilder.VideoDialog = VideoDialog;
})();
